import { forwardRef } from 'react';
import { SVG_xcircle } from '../elements/SVG';

const Select = forwardRef(({ label = false, options = {}, canBeEmpty = false, id = false, selected, error, ...other }, ref) => {
    return (
        <div className={`e__form__item${error ? ' rrr' : ''}`}>
            <div className='e__slct'>
                {label && <label htmlFor={id}>{label}</label>}
                <select
                    id={id}
                    ref={ref}
                    {...other}
                >
                    {canBeEmpty && <option value=""></option>}
                    {Object.keys(options).map(key => (
                        <option key={key} value={key} selected={selected === options[key]}>
                            {options[key]}
                        </option>
                    ))}
                </select>
            </div>
            {error && error !== 'unknown' && (
                <span className="e__txt__error">{error}</span>
            )}
            {error && (
                <span className="e__form__item__ico">
                    <SVG_xcircle />
                </span>
            )}
        </div>
    );
});

Select.displayName = 'Select';

export default Select;
